// | Utilities for creating reusable components with optional parameters.
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Restaumatic$dForm$dWidgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
const Modifier = x => x;
const unwrapModifier = v => v;
const fieldId = dictHasFieldId => x => Restaumatic$dForm$dWidgets.fieldId(dictHasFieldId)(x);
const element = () => tag => defaultProps => props => body => Specular$dDom$dElement.el(tag)(Data$dSemigroup.concatArray(defaultProps)(Data$dFunctor.arrayMap(unwrapModifier)(props)))(body);
const emptyElement = () => tag => defaultProps => props => element()(tag)(defaultProps)(props)(Restaumatic$dPrelude$dSpecular.wempty);
const classesModifierD = x => Specular$dDom$dElement.classesD(x);
const classesModifier = x => Specular$dDom$dElement.classes(x);
const classModifier = x => Specular$dDom$dElement.class_(x);
const attrsModifier = x => Specular$dDom$dElement.attrs(x);
const attrModifierD = x => x$1 => Specular$dDom$dElement.attrD(x)(x$1);
const attrModifier = x => x$1 => Specular$dDom$dElement.attr(x)(x$1);
const id = /* #__PURE__ */ attrModifier("id");
export {Modifier, attrModifier, attrModifierD, attrsModifier, classModifier, classesModifier, classesModifierD, element, emptyElement, fieldId, id, unwrapModifier};
